import * as React from 'react'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt'
import { styled } from '@mui/material/styles'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ProposalDownloadPopover from 'vendors/vendorUserRequestForProposals/vendorClosedProposalItem/ProposalDownloadPopover'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

const BackgroundCircle = styled(Box)(({ color, theme: { palette, spacing } }) => ({
  display: 'flex',
  width: '36px',
  height: '36px',
  backgroundColor:
    color === 'blue' ? palette.primary.main : color === 'grey' ? palette.grey[300] : palette.common.black,
  borderRadius: '100px',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: spacing(2)
}))

const VendorClosedProposalItem: React.FC<{ proposal: ProposalHistory }> = ({ proposal }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flex: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
        {proposal.isWinningProposal && (
          <BackgroundCircle color="blue">
            <EmojiEventsIcon sx={{ color: 'white' }} />
          </BackgroundCircle>
        )}
        {!proposal.isWinningProposal && proposal.rfpStatus === 3 && (
          <BackgroundCircle>
            <ThumbDownAltIcon sx={{ color: 'white' }} />
          </BackgroundCircle>
        )}
        {!proposal.isWinningProposal && proposal.rfpStatus === 2 && (
          <BackgroundCircle color="grey">
            <QuestionMarkIcon sx={{ color: 'white' }} />
          </BackgroundCircle>
        )}
        <Box>
          <Typography sx={{ fontSize: 14 }} color="text.secondary">
            {`${proposal.buyerName} (${proposal.tenantName})`}
          </Typography>
          <Typography
            component={RouterLink}
            to={`/${proposal.proposalId}/view`}
            sx={{
              fontSize: 16,
              fontWeight: 'fontWeightMedium',
              color: 'text.primary',
              textDecoration: 'none',
              cursor: 'pointer',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            {proposal.rfpTitle}
          </Typography>
          <Typography sx={{ fontSize: 14, mt: 1 }} color="text.secondary">
            {`${t('due-date-was')} ${proposal.proposalDueDateDisplay}`}
          </Typography>
        </Box>
      </Box>
      <ProposalDownloadPopover proposal={proposal} />
    </Box>
  )
}

export default VendorClosedProposalItem
